import React from 'react';
import { string } from 'prop-types';

import classnames from 'classnames';

import { BuildIcon } from '../utils';

const namespace = 'ui-search-icon ui-search-icon--color-multicolor';
const ICON_ID = 'color_46671867';

const gradientId = `paint0_linear_${ICON_ID}`;

const IconColorMulticolor = (props) => (
  <BuildIcon
    {...props}
    className={classnames(namespace, props.className)}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    iconId={ICON_ID}
  >
    <circle cx="12" cy="12" r="12" fill={`url(#${gradientId})`} />
    <defs>
      <linearGradient
        id={gradientId}
        x1="3.71909"
        y1="4.39328"
        x2="21.6414"
        y2="20.4706"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.045" stopColor="#185EDC" />
        <stop offset="0.245" stopColor="#36D4E6" />
        <stop offset="0.415" stopColor="#2BAA5B" />
        <stop offset="0.61" stopColor="#E0BB00" />
        <stop offset="0.805" stopColor="#FC833F" />
        <stop offset="0.96" stopColor="#E43921" />
      </linearGradient>
    </defs>
  </BuildIcon>
);

IconColorMulticolor.propTypes = {
  className: string,
};

export default IconColorMulticolor;
